import { LocalizeNameSpaceTypes } from './name-space.types';
import { useLocale } from './useLocale';

export const useGlobalLocale = () => useLocale(LocalizeNameSpaceTypes.Global);
